module.exports = __webpack_public_path__ + "static/merch11Front-5883786c190eea10fd1b958e7b6d099c.png";